import { createContext, useContext } from 'react';

type ProcessContextValue = {
  processId?: string;
};

const ProcessContext = createContext<ProcessContextValue>({});

export const useProcess = () => useContext(ProcessContext);
